import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import ConfigDiff from '@/components/Cluster/ConfigDiff';
import { isVoid } from '@/utils/common';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

/**
 * @param {Object} props
 * @returns
 */
function Summary({ overview, loading }) {
  const items = [
    {
      title: 'Bookies',
      info: (
        <>
          <CountUp end={overview.activeBookieCount} duration={0.4} />/
          <CountUp end={overview.totalBookieCount} duration={0.4} />
        </>
      ),
      icon: 'other2',
      unit: overview.bkVersion,
      items: [
        {
          label: '读写',
          value: overview.readWriteBookieCount,
        },
        {
          label: '只读',
          value: overview.readOnlyBookieCount,
        },
      ],
    },
    {
      title: 'Ledgers',
      info: <CountUp end={overview.totalLedgerCount} duration={0.4} />,
      icon: 'other3',
    },
    {
      title: '待复制Ledgers',
      info: <CountUp end={overview.totalUnderReplicateCount} duration={0.4} />,
      icon: 'other4',
    },
    {
      title: '磁盘占比',
      info: isVoid(overview.averageDiskUsage) ? (
        '-'
      ) : (
        <CountUp end={overview.averageDiskUsage} duration={0.4} decimals={2} />
      ),
      icon: 'other2',
      unit: '%',
    },
    <ConfigDiff
      key={1}
      title='Similar Config'
      icon='other5'
      correct={overview.similarConfig}
      data={overview.similarConfigVOList || []}
    />,
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect((state) => ({
  overview: state.bookkeeper.overview,
  loading: state.bookkeeper.loading,
}))(Summary);
